import { InfoResponse } from "@/@types/growthos-api/schema/openapi";
import { Autocomplete } from "@/Components/v2/atoms/Autocomplete/Autocomplete";
import { TextField } from "@/Components/v2/atoms/TextField";
import { styled } from "@mui/material";

const StyledTextField = styled(TextField)(() => {
  return {
    width: "240px",
    "& .MuiAutocomplete-inputFocused": {
      fontWeight: 600,
    },
  };
});

interface AccountSelectorProps {
  selectedAccount: InfoResponse["currentOrganization"];
  accounts: InfoResponse["currentOrganization"][];
  onAccountSelected: (account: InfoResponse["currentOrganization"]) => void;
}

export const AccountSelector: React.FC<AccountSelectorProps> = ({
  selectedAccount,
  accounts,
  onAccountSelected,
}) => {
  return (
    <Autocomplete
      value={selectedAccount}
      options={accounts}
      getOptionLabel={(option: InfoResponse["currentOrganization"]) => option.displayName}
      isOptionEqualToValue={(
        option: InfoResponse["currentOrganization"],
        value: InfoResponse["currentOrganization"]
      ) => option.id === value.id}
      renderInput={(params) => <StyledTextField {...params} size="small" />}
      getOptionKey={(option: InfoResponse["currentOrganization"]) => option.id}
      onChange={(_, account) => onAccountSelected(account)}
      disableClearable
      disabled={accounts.length <= 1}
    />
  );
};
